import { render, staticRenderFns } from "./member_jf_supdeduct_detail.vue?vue&type=template&id=1126e9b6&scoped=true"
import script from "./member_jf_supdeduct_detail.vue?vue&type=script&lang=js"
export * from "./member_jf_supdeduct_detail.vue?vue&type=script&lang=js"
import style0 from "./member_jf_supdeduct_detail.vue?vue&type=style&index=0&id=1126e9b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1126e9b6",
  null
  
)

export default component.exports